'use strict';

var ad_gallery = function () {
  var self = this;

  self.init();
  self.bind();
};

ad_gallery.prototype.bind = function () {
  var self = this;

  jQuery(document).arrive(
    '.ad_gallery',
    function (localSelf) {
      localSelf.init_gallery();
    }.bind(null, self)
  );

  jQuery(document).on(
    'shown.bs.modal',
    function (localSelf) {
      localSelf.update_instances();
    }.bind(null, self)
  );

};

ad_gallery.prototype.init = function () {
  var self = this;

  // console.log('init ad_gallery');

  self.init_gallery();

};

ad_gallery.prototype.init_gallery = function () {
  var self = this;

  jQuery('.ad_gallery').each(function () {

    var element = jQuery(this);

    if (element.hasClass('st_mounted') === false) {

      var swiper_element = element.find('.swiper-container');

      var new_swiper = new Swiper(swiper_element, {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 30,
        effect: 'fade',
        onInit: function(swiper) {
          // console.log('se ha inicializado un ad_gallery');
          // console.log(swiper);
        }
      });

      self.instances.push(new_swiper);

      element.addClass('st_mounted');
    }

  });

};

ad_gallery.prototype.instances = [];

ad_gallery.prototype.update_instances = function () {
  var self = this;

  for (var i = 0; i < self.instances.length; i++) {
    self.instances[i].update();
  }

};

jQuery( document ).ready(function() {

  window.ad_gallery = new ad_gallery();

});






